import { render, staticRenderFns } from "./shopOrderSeckill.vue?vue&type=template&id=fac798aa&scoped=true"
import script from "./shopOrderSeckill.vue?vue&type=script&lang=js"
export * from "./shopOrderSeckill.vue?vue&type=script&lang=js"
import style0 from "./shopOrderSeckill.vue?vue&type=style&index=0&id=fac798aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac798aa",
  null
  
)

export default component.exports